import LocationPage, { LocationData } from './LocationPage';

const miamiData: LocationData = {
  city: 'Miami',
  state: 'Florida',
  stateAbbr: 'FL',
  slug: 'miami',
  heroTitle: 'Hire faster in Miami with smart automation',
  heroSubtitle: 'Miami businesses move fast. Your hiring should too. iHireFast auto-emails applicants, lets them self-schedule via Calendly, and gives you a dashboard to manage everything.',
  metaDescription: 'iHireFast helps Miami businesses hire faster with automated applicant emails, Calendly scheduling, custom application forms, and applicant tracking. Free to start.',
  industries: [
    { name: 'Hospitality & Tourism', icon: '🏖️', description: 'Hotels, restaurants, event venues, and cruise lines in Miami need to fill positions fast during peak seasons.' },
    { name: 'Healthcare', icon: '🏥', description: 'Clinics, hospitals, and home health agencies across Miami-Dade are constantly recruiting qualified staff.' },
    { name: 'Construction & Real Estate', icon: '🏗️', description: 'Miami\'s booming development scene means constant demand for construction workers, agents, and property managers.' },
    { name: 'Technology & Startups', icon: '💻', description: 'Miami\'s growing tech scene in Wynwood and Brickell needs developers, designers, and product managers.' },
    { name: 'Retail & Food Service', icon: '🛍️', description: 'From Brickell City Centre to Wynwood shops, retail and food service hiring never stops.' },
    { name: 'Logistics & Shipping', icon: '🚢', description: 'PortMiami and MIA airport drive massive demand for warehouse, logistics, and transportation workers.' },
  ],
  stats: [
    { label: 'Avg. Time to Hire', value: '3 days' },
    { label: 'Response Rate', value: '94%' },
    { label: 'Miami Businesses', value: '200+' },
    { label: 'Applicants Processed', value: '5K+' },
  ],
  neighborhoods: [
    'Downtown Miami', 'Brickell', 'Wynwood', 'Little Havana', 'Coral Gables',
    'Coconut Grove', 'Miami Beach', 'Doral', 'Kendall', 'Homestead',
    'Hialeah', 'Miami Gardens', 'North Miami', 'Aventura', 'Key Biscayne',
    'Midtown', 'Edgewater', 'Overtown', 'Liberty City', 'Miami Springs',
  ],
  testimonial: {
    quote: 'We went from spending 2 hours a day calling applicants to having interviews booked automatically. iHireFast changed how we hire at all three of our Miami locations.',
    name: 'Maria Torres',
    role: 'HR Director',
    company: 'Sol Restaurant Group',
  },
  localInsight: 'With a bilingual workforce and one of the lowest unemployment rates in Florida, Miami employers need to move fast. The best candidates are off the market in days. iHireFast gives you the speed advantage with instant auto-emails and self-service scheduling.',
  jobMarketDescription: 'Miami-Dade County is one of the fastest-growing job markets in the United States. With over 2.7 million residents and a thriving tourism, healthcare, and construction sector, businesses are competing for talent every day. The bilingual nature of the market means reaching candidates quickly is critical.',
};

export default function MiamiPage() {
  return <LocationPage data={miamiData} />;
}
